import React from 'react'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  styled,
} from '@mui/material'
import { IoIosClose } from 'react-icons/io'
import Controls from '../Controls/Controls'
import Dialog from './Dialog'

const CloseButton = styled(IconButton)({
  position: 'absolute',
  right: 12,
  top: 12,
})

const ActionContainer = styled(DialogActions)({
  margin: '1rem',
})

const DialogRoot = styled(Dialog)({
  '& .MuiTypography-h6': {
    fontSize: '1.5rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  '& .MuiDialogContent-root': {
    color: '#333',
    fontSize: '1.125rem',
    textAlign: 'center',
  },
})

const ConfirmDialog = ({
  open,
  setOpen,
  title,
  content,
  yesAction,
  noAction,
  acceptButton,
  rejectButton,
  videoControl,
}) => {
  const handleClose = () => {
    setOpen(false)
  }

  const handleRefresh = () => {
    handleClose()
    window.location.reload()
  }

  return (
    <>
      <DialogRoot fullWidth open={open} onClose={handleClose}>
        <CloseButton onClick={handleClose}>
          <IoIosClose />
        </CloseButton>
        <DialogTitle>{title}</DialogTitle>
        <Divider />
        <DialogContent>{content}</DialogContent>
        <Divider />
        <ActionContainer>
          {(yesAction || acceptButton) && (
            <Controls.Button
              size="large"
              text={acceptButton || 'YES'}
              onClick={() => {
                yesAction()
                handleClose()
              }}
              sx={{
                backgroundColor: '#585858',
                backgroundImage: 'unset',
              }}
            />
          )}
          <Controls.Button
            size="large"
            text={rejectButton || 'NO'}
            onClick={
              videoControl
                ? handleRefresh
                : () => {
                    noAction()
                    handleClose()
                  }
            }
          />
        </ActionContainer>
      </DialogRoot>
    </>
  )
}

export default ConfirmDialog
